import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface ISessionLog {
  _id: string;
  userId: string;
  username: string;
  role: string;
  loginAt: string;
  logoutAt: string | null;
  sessionDurationSec: number;
  lastSeenAt: string;
}

export interface SessionLogPayload {
  pageIndex: number;
  pageSize: number;
  filters?: {
    dayStart?: string;
    dayEnd?: string;
    searchText?: string;
  };
}

@Injectable({ providedIn: "root" })
export class SessionLogService {
  constructor(private http: HttpClient) {}

  getPagedSessionLogs(payload: SessionLogPayload): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/session-logs/paged`,
      payload
    );
  }

  getActiveSessions(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/session-logs/active`);
  }
}
